export interface OpiTriggerItem {
  title: string;
  description: string;
  amount: number;
}

export interface OpiTriggerPreauth {
  action: 'preauth';
  props: {
    currency: 'EUR' | 'GBP';
    total: number;
    items: OpiTriggerItem[];
  };
}

export interface OpiTriggerConfirmPreauth {
  action: 'confirmpreauth';
  props: {
    currency: 'EUR' | 'GBP';
    total: number;
    items: OpiTriggerItem[];
  };
}

export interface OpiTriggerTopup {
  action: 'topup';
  props: {
    total: number;
    currency: 'EUR' | 'GBP';
    items: OpiTriggerItem[];
  };
}

export interface OpiTriggerCheckout {
  action: 'checkout';
  props: {
    total: number;
    currency: 'EUR' | 'GBP';
    items: OpiTriggerItem[];
  };
}

export interface OpiTriggerRelease {
  action: 'release';
  props: {
    total: number;
    currency: 'EUR' | 'GBP';
    items: OpiTriggerItem[];
  };
}

export type OpiTriggerType =
  | OpiTriggerPreauth
  | OpiTriggerConfirmPreauth
  | OpiTriggerTopup
  | OpiTriggerCheckout
  | OpiTriggerRelease;
